/*
 * Copyright (c) 2023, Salesforce, Inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */

/**
 * Cache time configuration constants.
 *
 * Kept in a separate file so ssr.js can import them directly.
 * (ssr.js can't import from constants.js because it re-exports from
 * @salesforce/retail-react-app/app/constants which uses ESM that babel-node can't handle)
 */

export const MAX_CACHE_AGE_CMS = 60 * 10 // 10 mins cache time
export const MAX_CACHE_AGE_S = 60 * 60 // 60 mins cache time
export const MAX_CACHE_AGE_M = 60 * 60 * 24 // 24 hours cache time
export const MAX_CACHE_AGE_L = 60 * 60 * 24 * 30 // 30 days cache time
export const MAX_CACHE_AGE_XL = 60 * 60 * 24 * 365 // 1 year cache time

export const STALE_WHILE_REVALIDATE_S = 60 * 60 // 60 mins cache time
export const STALE_WHILE_REVALIDATE_M = 60 * 60 * 24 // 24 hours cache time
export const STALE_WHILE_REVALIDATE_L = 60 * 60 * 24 * 30 // 30 days cache time
export const STALE_WHILE_REVALIDATE_XL = 60 * 60 * 24 * 365 // 1 year cache time
